export default {
	CAPTIONS: 'captions',
}
